import { render, staticRenderFns } from "./shopList.vue?vue&type=template&id=7b13f0b2&scoped=true"
import script from "./shopList.vue?vue&type=script&lang=ts"
export * from "./shopList.vue?vue&type=script&lang=ts"
import style0 from "./shopList.vue?vue&type=style&index=0&id=7b13f0b2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b13f0b2",
  null
  
)

export default component.exports